import type { JSX } from 'react'

export const GhostIcon = (): JSX.Element => (
  <use href='#ghost' height='100%' width='100%' />
)
